import React, { useContext, useEffect, useRef, useState } from "react";
import {
  acceptInvitation,
  declineInvitation,
  deleteInvitation,
  getOrganization,
} from "../../../../services/api/organization.api";

import { actions, OrganizationContext } from "../../store/Organization.store";
import { toast, ToastContainer } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";
import { Tooltip } from "../../../../components";
import { OverlayTrigger } from "react-bootstrap";

export default function ReceivedInvitations({
  invitations,
  hasOrganization = false,
}) {
  const { state, dispatch } = useContext(OrganizationContext);
  const [organizationInvitations, setOrganizationInvitations] = useState([]);
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const handleAcceptInvitation = async (invitation) => {
    setLoading(true);
    const { data, statusCode } = await acceptInvitation({
      organizationId: invitation.organizationId._id,
      inviter: invitation.inviter,
    });
    if (statusCode === 200) {
      getOrganization().then(({ data, statusCode: status }) => {
        dispatch({ type: actions.GET_ORGANIZATION, payload: data });
        if (status === 200) {
          setLoading(false);
          window.location = "/organization";
        }
      });
    } else if (statusCode >= 400) {
      toast.error(data.message || data.message);
    }
  };

  const handleDeclineInvitation = async (invitation) => {
    const { data, statusCode } = await declineInvitation({
      organizationId: invitation.organizationId._id,
      inviter: invitation.inviter,
    });
    if (statusCode === 200) {
      setOrganizationInvitations(
        organizationInvitations.filter((el) => el !== invitation)
      );
    }
  };

  useEffect(() => {
    setOrganizationInvitations(invitations);
  }, []);
  return (
    <div className="join-invite-msg" style={{ minWidth: "100%" }}>
      {organizationInvitations.map((invitation, i) => (
        <div key={i} className="invite-notification-ui">
          <div className="left-ui">
            <figure>
              <img
                src={
                  invitation.inviterPicture || "/assets/images/ic_profile.png"
                }
                alt=""
              />
            </figure>
            <div className="content-ui">
              <p>
                <strong>{invitation.inviter}</strong>{" "}
                <FormattedMessage id={"organization.createJoin.invitedYouOn"} />{" "}
                <strong className="capital">
                  ‘ {invitation.organizationId.name} ’
                </strong>
              </p>
            </div>
          </div>
          <div className="right-ui">
            <span className="time-ui" />
            {hasOrganization ? (
              <OverlayTrigger
                placement={"top"}
                key={"quickview"}
                overlay={(props) =>
                  Tooltip({
                    ...props,
                    data: intl.formatMessage({
                      id: "organization.leaveYourOrganizationFirst",
                    }),
                  })
                }
                defaultShow={false}
              >
                <a
                  className="btn-ui cursorNotAllowed"
                  style={{ color: "#999" }}
                >
                  <span className="icon">
                    <img src="/images/ic-chk-permision.svg" alt="" />
                  </span>
                  <FormattedMessage id={"accept"} />
                </a>
              </OverlayTrigger>
            ) : (
              <a
                className="btn-ui"
                onClick={() =>
                  !loading ? handleAcceptInvitation(invitation) : false
                }
              >
                <span className="icon">
                  <img src="/images/ic-chk-permision.svg" alt="" />
                </span>
                <FormattedMessage id={"accept"} />
              </a>
            )}
            <a
              className="btn-ui"
              style={{ marginLeft: 20 }}
              onClick={() => handleDeclineInvitation(invitation)}
            >
              <span className="icon">
                <img src="/images/ic-chk-permision.svg" alt="" />
              </span>
              <FormattedMessage id={"decline"} />
            </a>
          </div>
          <ToastContainer position="bottom-right" style={{ top: 100 }} />
        </div>
      ))}
    </div>
  );
}
